import EDatePicker from './components/EDatePicker';
import ETimePicker from './components/ETimePicker';
import ERadioGroup from './components/ERadioGroup';
import EButtonGroupField from './components/EButtonGroupField';
import ECheckboxGroup from './components/ECheckboxGroup';
import ESelect from './components/ESelect';
import EAutocomplete from './components/EAutocomplete';
import ESwitch from './components/ESwitch';
import EAutocompleteWithCreate from './components/EAutocompleteWithCreate';
import EDocumentPreview from './components/EDocumentPreview';
import EFilledTextField from './components/EFilledTextField';
const fieldRenderers = {
    '1': EFilledTextField,
    '2': EFilledTextField,
    '3': EFilledTextField,
    '4': EDatePicker,
    '5': ETimePicker,
    '6': EFilledTextField,
    '7': ERadioGroup,
    '8': EButtonGroupField,
    '9': ECheckboxGroup,
    '10': ESelect,
    '11': EAutocomplete,
    '12': ESwitch,
    '18': EAutocompleteWithCreate,
    '19': EDocumentPreview,
    '20': EAutocomplete
};
export default fieldRenderers;
